<div class="header">
    <div class="p-grid">
        <div class="p-col-6 p-lg-6 p-pb-0">
            <div class="p-d-flex">
                <p-dropdown [options]="allVendorsDD" [filter]="true" [(ngModel)]="selectedVendor" optionLabel="name"
                    placeholder="Select Vendor" appendTo="body" (onChange)="getItemReceiptList()" class="vendorClass"
                    optionDisabled="hasPurchaseOrder"></p-dropdown>
                <span style="color: red;" class="p-ml-1">*</span>
            </div>
        </div>
        <div class="p-col-6 p-lg-6 p-pb-0">
            <div class="p-d-flex">
                <p-dropdown [options]="allLocationsDD" [filter]="true" [(ngModel)]="selectedLocation"
                    optionLabel="customName" placeholder="Select location" appendTo="body" [disabled]="!selectedVendor"
                    (onChange)="getItemReceiptList()" class="vendorClass"></p-dropdown>
                <span style="color: red;" class="p-ml-1">*</span>
            </div>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-4 p-lg-6 p-pb-0">
            <div class="p-d-flex p-mt-4" *ngIf="isAllowPostingPeriod">
                <label style="min-width: 120px;">Posting Period<span style="color: red">*</span>:</label>
                <div style="flex: 1; max-width: 175px; margin-left: 0;">
                    <app-posting-period-selector [transactionDate]="postingDate" [compactDropdown]="true"
                        [moduleName]="'Bill'" [selectedPostingPeriod]="currentPostingPeriodInfo"
                        [isViewMode]="false" (postingInfoChange)="onPostingInfoChange($event)"
                    ></app-posting-period-selector>
                </div>
            </div>
        </div>
        <div class="p-col-6 p-lg-6 p-pb-0">
            <div class="p-d-flex p-mt-4" *ngIf="selectedVendor && (baseCurrency?.currencyId!==selectedVendor?.currencyId)">
                1 {{baseCurrency?.code}} = {{vendorExchangeRate}} {{selectedVendor?.currencyCode}}
                <span class="btnBars" (click)="showEditExchangeRate($event)">
                    <i class="pi pi-pencil"></i>
                </span>
            </div>
        </div>
        <p-overlayPanel #editCurrency [showCloseIcon]="true" styleClass="no-padding custom-overlay-header" [style]="{width: '300px'}">
            <div class="panel-header">
                <h5 class="p-mb-0">Edit Exchange Rate</h5>
            </div>
            @if(selectedVendor){
            <app-edit-exchangerate [vendorDetails]="selectedVendor" [orgCurrency]="orgCurrency"
                [vendorCurrencyExchangeRate]="vendorExchangeRate"
                (closeDialog)="closeCurrencyDialog($event)"></app-edit-exchangerate>
            }
        </p-overlayPanel>
    </div>
</div>
<div class="card">
    <p-table [value]="irList" styleClass="p-datatable-gridlines" responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th id="no.">Item Receipt No.</th>
                <th id="date.">Item Receipt Date</th>
                <th id="po.">PO No.</th>
                <th id="location">Location</th>
                <th id="amount">Amount</th>
                <th id="action" style="width: 2rem;" class="action">
                    <span class="btnBars" (click)="addIRdata()" *ngIf="selectedVendor">
                        <i class="pi pi-plus"></i>
                    </span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{product.rpoNumber}}</td>
                <td>{{product.rpoDate | date: 'MM/dd/yyyy'}}</td>
                <td>{{product.poNumber}}</td>
                <td>{{product.location}}</td>
                <td>{{selectedVendor?.symbol}} {{product.netAmount | customNumberFormat: length }}</td>
                <td></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td colspan="4" class="p-text-right">{{itemReceiptTemplate &&
                    itemReceiptTemplate.labels_footer &&
                    itemReceiptTemplate.labels_footer[0]?.labelname}}
                </td>
                <td colspan="3"> {{subTotal | customNumberFormat: length| currencySymbol}}</td>
            </tr>
            <tr>
                <td colspan="4" class="action">
                    <div class="p-d-flex" style="flex-direction: row-reverse;">
                        <div class="p-d-flex">
                            <p-dropdown placeholder="Select" [options]="allDiscounts" (onChange)="findsum(irList,false)"
                                class="footer-dd" optionLabel="additionalDescription" appendTo="body"
                                [(ngModel)]="selectedValueOption" [ngModelOptions]="{standalone: true}"></p-dropdown>
                            <p-inputNumber [(ngModel)]="discountAmount" (focusout)="findsum(irList,true)" mode="decimal"
                                [disabled]="selectedValueOption?.type?.name == 'Percentage' || selectedValueOption?.type?.name == '%'"
                                [minFractionDigits]="length" [maxFractionDigits]="length" [min]="0"
                                [max]="selectedValueOption?.description=='%'?99.99:subTotal" class="footer-input"
                                [ngModelOptions]="{standalone: true}"></p-inputNumber>
                        </div>
                        <span class="p-mr-3 p-pt-1">
                            {{itemReceiptTemplate && itemReceiptTemplate.labels_footer &&
                            itemReceiptTemplate.labels_footer[2]?.labelname}}
                        </span>
                    </div>
                </td>
                <td colspan="3"> {{ discount | customNumberFormat: length| currencySymbol}}</td>
            </tr>
            <tr>
                <td colspan="4" class="p-text-right">{{itemReceiptTemplate &&
                    itemReceiptTemplate.labels_footer &&
                    itemReceiptTemplate.labels_footer[3]?.labelname}}
                </td>
                <td colspan="3"> {{orderTotal | customNumberFormat: length| currencySymbol}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>


<!-- item receipt list -->
<p-dialog header="Item Receipt List" [(visible)]="displayItemReceiptList" [modal]="true" [responsive]="true"
    [style]="{width: '80vw'}" (onHide)="selectedIRList=[];">
    <div class="card">
        <p-table [value]="irListTB" styleClass="p-datatable-gridlines" responsiveLayout="scroll"
            selectionMode="multiple" [(selection)]="selectedIRList" dataKey="rpoNumber">
            <ng-template pTemplate="header">
                <tr>
                    <th id="no">Item Receipt No.</th>
                    <th id="date">Item Receipt Date</th>
                    <th id="po">PO No.</th>
                    <th id="location">Location</th>
                    <th id="amt">Amount</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                <tr [pSelectableRow]="product" [pSelectableRowIndex]="rowIndex">
                    <td>{{product.rpoNumber}}</td>
                    <td>{{product.rpoDate | date: 'MM/dd/yyyy'}}</td>
                    <td>{{product.poNumber}}</td>
                    <td>{{product.location}}</td>
                    <td>{{product.netAmount | multicurrency: (product.exchangeRate ?? baseCurrency?.exchangeRate) : (product.symbol ?? baseCurrency?.symbol): length}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td colspan="7" class="p-text-center">
                        No item receipt found.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayItemReceiptList = false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate)" pButton label="Save" (click)="saveIRList()"></button>
    </p-footer>
</p-dialog>